"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginStatusCheckerPlugin = void 0;
const student_interfaces_1 = require("@studyportals/student-interfaces");
const __1 = __importDefault(require(".."));
class LoginStatusCheckerPlugin {
    initiate() {
        const eventAggregationService = window["EventAggregationService"];
        if (!eventAggregationService) {
            return;
        }
        eventAggregationService.subscribeTo(student_interfaces_1.SessionServiceReadyEvent.EventType, this, true);
        eventAggregationService.subscribeTo(student_interfaces_1.SessionCreatedEvent.EventType, this);
    }
    notify(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (event.eventType === student_interfaces_1.SessionServiceReadyEvent.EventType) {
                return this.checkSession(event.sessionService);
            }
            if (event.eventType === student_interfaces_1.SessionCreatedEvent.EventType) {
                __1.default.mutations.setLoggedInFlag(true);
            }
        });
    }
    checkSession(sessionService) {
        return __awaiter(this, void 0, void 0, function* () {
            const session = yield sessionService.getSession();
            if (session === null) {
                __1.default.mutations.setLoggedInFlag(false);
                return;
            }
            __1.default.mutations.setLoggedInFlag(true);
        });
    }
}
exports.LoginStatusCheckerPlugin = LoginStatusCheckerPlugin;
